import styled from 'styled-components'

const darkColor = props => props.theme.global.colors['dark-2']

export const Heading = styled.h1`
  margin: 0 0 16px;
  font-size: 16px;
  color: ${darkColor};
  font-weight: 600;
  line-height: 165%;
`

export const Section = styled.section`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;

  @media screen and (max-width:992px) {
    gap: 8px;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`

export const Label = styled.p`
  font-size: 14px;
  color: ${darkColor};
  font-weight: 400;
  line-height: 165%;
  margin: 0;
`

export const ImageBox = styled.div`
  width: 40px;
  height: 40px;
`